import React, { Suspense, useRef, useState, useEffect, useMemo } from 'react'
import './App.css';
import * as THREE from 'three';
import { Stats, Html, Center, OrbitControls, MeshDistortMaterial, MeshWobbleMaterial, Shadow } from '@react-three/drei';
import { Canvas, extend, useThree, useFrame } from '@react-three/fiber'
import { useLoader } from '@react-three/fiber'
import { useTexture } from '@react-three/drei';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import {FireMaterial} from './FireMaterial.js'

import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass'
import { TextureLoader } from 'three/src/loaders/TextureLoader.js';
import { MeshBasicMaterial, SphereGeometry } from 'three';
import { MeshStandardMaterial } from 'three';
import { Vector3 } from 'three';

extend({ EffectComposer, RenderPass, UnrealBloomPass });


function Effect({ down }) {
  const composer = useRef()
  const { scene, gl, size, camera } = useThree()
  const aspect = useMemo(() => new THREE.Vector2(size.width, size.height), [size])
  useEffect(() => void composer.current.setSize(size.width, size.height), [size])
  useFrame(() => composer.current.render(), 1)
  return (
    <>
    <effectComposer ref={composer} args={[gl]}>
      <renderPass attachArray="passes" scene={scene} camera={camera} />
      <unrealBloomPass attachArray="passes" args={[aspect, 1, 0.5, 0]} />
    </effectComposer>
    </>
  )
}


function lerp(value1, value2, amount) {
	amount = amount < 0 ? 0 : amount;
	amount = amount > 1 ? 1 : amount;
	return value1 + (value2 - value1) * amount;
};

let paths = [];
function Organism() {
  const ref = useRef();
  const {scene, camera, gl} = useThree();
  let loaded = false;
  const gltf = useLoader(GLTFLoader, './head.glb');
  const texture = useMemo(() => new THREE.TextureLoader().load('./lines.png'), []);
  const spheres = new THREE.Group();
  const amount = 50;
  texture.repeat.set(1,0.5)
  texture.wrapS = THREE.RepeatWrapping;
  texture.wrapT = THREE.RepeatWrapping;
  let shadow = new THREE.Mesh(gltf.scene.children[0].geometry, new THREE.MeshPhysicalMaterial({roughness: 0.3, metalness: 0.7, flatShading: true, transparent: true, opacity: 0.0}))
  shadow.scale.set(0.98,0.98,0.98);
  
  var fadeMaterial = new THREE.MeshBasicMaterial({
    color: 0x000000,
    transparent: true,
    opacity: 0.1
  });
  var fadePlane = new THREE.PlaneBufferGeometry(100, 100);
  var fadeMesh = new THREE.Mesh(fadePlane, fadeMaterial);

  if(camera.children.length === 0) {
      camera.add(fadeMesh);
      scene.add(camera);
      
  }
  fadeMesh.position.set(0,0,-1);
  camera.position.set(0, -1, 6);
  camera.lookAt(new THREE.Vector3(0,0,0))

  useEffect(() => {
    if(loaded) return;
    else loaded = true;
    // ref.current.material = new THREE.MeshPhysicalMaterial({roughness: 0.9, metalness: 0.7,wireframe:true});
    ref.current.add(shadow)

    let geometry = ref.current.geometry.attributes.position.array;

    for(let i=0; i < amount * 2; i++) {
      let randPoint1 = new THREE.Vector3(Math.sin(Math.PI * 2 / amount * i) * 20, Math.cos(Math.PI * 2 / amount * i) * 20, 7);

      let rand2 = Math.floor(Math.random() * geometry.length / 3) * 3;
      let randPoint2 = new THREE.Vector3(geometry[rand2], geometry[rand2+1], geometry[rand2+2]+0.1);

      let midPoint = new THREE.Vector3(Math.sin(Math.PI * 2 / amount * i) * 2 + Math.random() * 2 - 1, Math.cos(Math.PI * 2 / amount * i) * 2 + Math.random() * 2 - 1, 3);
      
      let curve = new THREE.CatmullRomCurve3([randPoint1, midPoint, randPoint2]);
      paths.push(curve);
      let tubeGeometry = new THREE.TubeGeometry( curve, 20, 0.03, 5, false );

      let sphere = new THREE.Mesh(tubeGeometry, new THREE.MeshPhysicalMaterial({roughness: 0.3, metalness: 0.6,  map: texture}));
      // sphere.position.copy(randPoint1);
      ref.current.add(sphere)
    }
    
    console.log(spheres)
    gl.autoClearColor = false;
    // console.log(ref.current);
  })

  useFrame(({mouse, clock}) => {
    // console.log(ref.current.children[0].geometry.parameters.path)
    texture.offset.set(-clock.getElapsedTime() / 5, 0.5);
    // ref.current.rotation.set(-mouse.y / 5 + Math.PI, -mouse.x / 5, Math.PI);

    let factor = Math.sin(clock.getElapsedTime() / 5 - Math.PI / 2) / 2 + 0.5;
    if(factor > 0.0) {
      shadow.material.opacity = factor;
    } else shadow.material.opacity = 0;
    
    // ref.current.material.uniforms.time.value = clock.getElapsedTime() / 10;
  })

  return (
    <>
    <primitive ref={ref} object={gltf.scene.children[0]} >
      <meshPhysicalMaterial roughness={0.9} metalness={0.7} wireframe={true} />
    {/* <fireMaterial color0={new THREE.Vector3(20,20,20)} color1={new THREE.Vector3(65,0,170)} transparent={true} depthWrite={false}/> */}
      <Spheres amount={amount * 2} />
    </primitive>
    </>
  )
}

const dummy = new THREE.Object3D();

function Spheres({amount}) {
  const { scene, camera, gl } = useThree();

  let material = new THREE.MeshBasicMaterial({ color: 'white'});
  const sphereGeometry = new SphereGeometry(0.05);
  const ref = useRef();

  useFrame(({mouse, clock}) => {
    for(let i = 0; i < amount; i++) {
      
      dummy.position.copy(paths[i]?.getPoint(Math.sin(clock.getElapsedTime() / 5 - Math.PI / 2) / 2.8 + 0.5) );
      dummy.updateMatrix();
      ref.current.setMatrixAt(i, dummy.matrix);
      // spheres.children[i]?.position.copy(paths[i].getPoint(Math.sin(clock.getElapsedTime() / 5 - Math.PI / 2) / 2 + 0.5))
    }
    ref.current.instanceMatrix.needsUpdate = true;
  })
  
  return <instancedMesh ref={ref} args={[sphereGeometry, material, amount]} />;
}

function Fire() {
  const ref = useRef();
  useFrame(({clock}) => {
    ref.current.material.uniforms.time.value = clock.getElapsedTime() / 2;
  })

  return (
  <mesh ref={ref} position={[0,0,-10]} scale={[1,2,1]} rotation={[0,0,Math.PI]}>
    <planeGeometry args={[1000,1000]}/>
    <fireMaterial color0={new THREE.Vector3(192,80,0)} color1={new THREE.Vector3(65,0,170)}/>
  </mesh>);
}

function App() {


  return (
    <div id="wrapper" onMouseDown={() => {console.log("PRESSED")}}>
  <Canvas>
    <Effect />
      <pointLight position={[0,3,10]} intensity={0.1} color={'white'}/>
      <pointLight position={[0,3,-10]} intensity={0.1} color={'white'}/>
      <Suspense  fallback={null}>
        <Organism />
      </Suspense>
    {/* <Fire /> */}
    <OrbitControls panSpeed={0} minAzimuthAngle={-Math.PI / 2} maxAzimuthAngle={Math.PI / 2} /> 
    {/* <Stats /> */}
  </Canvas>
  </div>
  );
}

export default App;
